import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Facebook, Instagram, Globe, Music2 } from "lucide-react";

const FIELDS = [
  { key: "facebook", label: "Facebook", Icon: Facebook, ph: "https://facebook.com/votrepage" },
  { key: "instagram", label: "Instagram", Icon: Instagram, ph: "https://instagram.com/votrecompte" },
  { key: "tiktok", label: "TikTok", Icon: Music2, ph: "https://tiktok.com/@votrecompte" },
  { key: "website", label: "Site web", Icon: Globe, ph: "https://votre-site.fr" },
];

export function SocialSettings() {
  const [social, setSocial] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings").then(({ data }) => setSocial(data.social)); }, []);

  const save = async () => {
    setBusy(true);
    try { await api.put("/settings", { social }); toast.success("Réseaux sociaux enregistrés"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (!social) return null;
  return (
    <div className="rounded-2xl bg-white border border-border p-5" data-testid="social-settings">
      <h2 className="font-serif text-2xl text-olive mb-1">Réseaux sociaux</h2>
      <p className="text-sm text-muted-foreground mb-4">Les liens renseignés apparaissent dans l'en-tête et le pied de page du site.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {FIELDS.map(({ key, label, Icon, ph }) => (
          <div key={key}>
            <Label className="flex items-center gap-1.5 text-xs"><Icon className="w-3.5 h-3.5" /> {label}</Label>
            <Input value={social[key]} onChange={(e) => setSocial({ ...social, [key]: e.target.value })} placeholder={ph} data-testid={`social-input-${key}`} />
          </div>
        ))}
      </div>
      <Button onClick={save} disabled={busy} className="mt-4 bg-olive text-white" data-testid="social-save-button">{busy ? "..." : "Enregistrer"}</Button>
    </div>
  );
}
